<div>
  <div class="logo-container">
    <img class="img-fluid logo-img" src="./assets/logo-login.png" (click)="goToHomePage()">

    <!-- <div>
      <button mat-stroked-button color="outline-not-selected" class="eng" (click)="goToEnglishPage()">{{translation['English']}}</button>
      <button mat-stroked-button color="outline" (click)="goToArabicPage()">{{translation['Arabic']}}</button>
    </div> -->
  </div>
    <div class="grid">
        

        <div class="col-12">
          <div class="arabic">
            <mat-horizontal-stepper linear="true" #stepper>
              <mat-step [stepControl]="detailForm" [editable]="true">
                <form [formGroup]="detailForm">
                  <ng-template matStepLabel>{{translation['Plan']}}</ng-template>
                  <div class="grid">
                    <div class="col-12 field-container rtl">
                      <div class="form-label">{{translation['Gender']}}</div>
                      <mat-radio-group formControlName="Gender" class="gender-container">
                        <ng-container *ngFor="let city of genderList">
                          <mat-radio-button [value]="city['value']" (change)="getAllCityByGenderForJoinOnline($event)">{{city['label']}}</mat-radio-button>
                        </ng-container>
                      </mat-radio-group>
                    </div>
                    <div class="col-12 field-container">
                      <div class="form-label">{{translation['Select']}} {{translation['Location']}}</div>
                      <mat-radio-group formControlName="CityId" class="city-container">
                        <ng-container *ngFor="let city of dropDownValues['CityList']">
                          <mat-radio-button [value]="city['value']" (change)="getAllLocationByCityGenderForJoinOnline($event)">{{city['label']}}</mat-radio-button>
                        </ng-container>
                      </mat-radio-group>
                    </div>
                    <div class="col-12 field-container" style="margin-bottom: 0.5rem !important;">
                      <div class="form-label">{{translation['ChooseYourGym']}}<span class="required-class"> *</span></div>
                      <mat-form-field>
                        <mat-select placeholder="{{translation['Choose']}}" formControlName="LocationId" autocomplete="off" (selectionChange)="itemListWithoutCustomer()">
                          <mat-option *ngFor="let club of dropDownValues['LocationList']" [value]="club.value">
                            {{club.label}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-12 field-container" *ngIf="itemList">
                      <a target="_blank" (click)="getDirections()" class="get-directions">{{translation['GetDirections']}}</a>
                    </div>
                    <div class="col-12 field-container plan-main-container" *ngIf="itemList">
                      <div class="form-label dir-rtl">{{translation['SelectMembership']}}<span class="required-class"> *</span></div>
                      <owl-carousel-o [options]="carouselOptions">
                        <ng-container *ngFor="let item of itemList">
                          <ng-template carouselSlide>
                              <div class="plan-container" [ngClass]="{'selected': isSelected(item)}">
                                <ng-container *ngIf="item['MostPopularflag']">
                                  <div *ngIf="selectedPlan !== item" class="best-choice">★ {{item['MostPopularflag']}}</div>
                                  <div *ngIf="selectedPlan === item" class="great-choice">★ {{translation['GreatChoice']}}</div>
                                </ng-container>
                                
                                <br>
                                <div class="plan-head-section">
                                  <div class="plan-header">{{item['ItemDescriptionLanguage2']}}</div>
                                  <div class="plan-head-img-section">
                                    <img src="./assets/icons/info.png" (click)="showDescription(item)">
                                  </div>
                                </div>
                              
                      
                                <div class="plan-description">
                                  <div class="description" [innerHTML]="item['ItemDetailDescription']"></div>
                                </div>
                                <div class="plan-footer">
                                  <div class="plan-footer-details">
                                    <span class="symbol"><img src="./assets/currency_symbol.png"/></span>&nbsp;<span class="currency">{{item['Price']}}</span>
                                  </div>
                                  <div class="plan-footer-select-button">
                                    <button class="select-plan-btn" mat-stroked-button (click)="selectPlan(item)">{{translation['SelectPlan']}}</button>
                                  </div>
                                </div>
                              </div>
                            
                          </ng-template>
                        </ng-container>
                      </owl-carousel-o>
                      <!-- <div class="plan-container-flex">
                        
                      </div> -->
                    </div>
                    <div class="footer">
                      <button mat-button (click)="addTransactionItem()" [disabled]="detailForm.invalid || selectedPlan == null || selectedPlan == undefined">{{translation['Next']}}</button>
                    </div>
                  </div>
                </form>
              </mat-step>
              <mat-step [editable]="true">
                <ng-template matStepLabel>{{translation['Details']}}</ng-template>
                <div class="grid btn-header">
                  <div class="col-12">
                    <button class="back-button" mat-button matStepperPrevious>{{translation['Back']}}</button>
                  </div>
                </div>
                <div class="detail-bg-container" [formGroup]="personalDetailForm">
                  <div class="personal-details-header">{{translation['PersonalDetails']}}</div>
                  <div class="grid personal-detail-form">
                    <div class="col-12 field-container">
                      <div class="form-label">{{translation['Email']}}<span class="required-class"> *</span></div>
                      <mat-form-field>
                        <input type="email" matInput placeholder="example@gmail.com" formControlName="Email" autocomplete="off" (input)="onEmailInput($event)">
                        <mat-error *ngIf="personalDetailForm.controls['Email'].invalid">{{translation['ValidEmail']}}</mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-6 field-container pad-left">
                      <div class="form-label">{{translation['FirstName']}}<span class="required-class"> *</span></div>
                      <mat-form-field>
                        <input type="text" matInput formControlName="FirstName" autocomplete="off" (keydown)="allowOnlyEnglish($event)" (paste)="blockNonEnglishPaste($event)">
                        <mat-error *ngIf="personalDetailForm.controls.FirstName.errors && (personalDetailForm.controls.FirstName.dirty || personalDetailForm.controls.FirstName.touched)">
                          <p *ngIf="personalDetailForm.controls.FirstName.errors?.required">{{translation['FirstName']}} {{translation['isRequired']}}</p>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-6 field-container pad-right">
                      <div class="form-label">{{translation['LastName']}}<span class="required-class"> *</span></div>
                      <mat-form-field>
                        <input type="text" matInput formControlName="LastName" autocomplete="off" (keydown)="allowOnlyEnglish($event)" (paste)="blockNonEnglishPaste($event)">
                        <mat-error *ngIf="personalDetailForm.controls.LastName.errors && (personalDetailForm.controls.LastName.dirty || personalDetailForm.controls.LastName.touched)">
                          <p *ngIf="personalDetailForm.controls.LastName.errors?.required">{{translation['LastName']}} {{translation['isRequired']}}</p>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-6 field-container pad-left">
                      <div class="form-label">{{translation['MobileNumber']}}<span class="required-class"> *</span></div>
                      <div style="display: flex;">
                        <mat-form-field style="width:20%;margin-left:1rem;">
                          <mat-select formControlName="DialingCode" autocomplete="off" required>
                            <mat-option *ngFor="let code of dropDownValues['CountryCodeList']" [value]="code.value">
                              {{code.label}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                          <input type="text" matInput formControlName="MobileNo" (input)="checkInputNumber($event)" maxlength="10" autocomplete="off" (keydown)="allowOnlyEnglish($event)" (paste)="blockNonEnglishPaste($event)">
                          <mat-hint class="hint-color">e.g. 5XXXXXXXXX</mat-hint>
                          <mat-error *ngIf="personalDetailForm.controls.MobileNo.errors && (personalDetailForm.controls.MobileNo.dirty || personalDetailForm.controls.MobileNo.touched)">
                            <p *ngIf="personalDetailForm.controls.MobileNo.errors?.required">{{translation['MobileNumber']}} {{translation['isRequired']}}</p>
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-6 field-container pad-right">
                      <div class="form-label">{{translation['Nationality']}}<span class="required-class"> *</span></div>
                      <mat-form-field>
                        <mat-select placeholder="{{translation['Choose']}}" formControlName="NationalityId" autocomplete="off" >
                          <mat-option *ngFor="let nation of dropDownValues['CountryList']" [value]="nation.value">
                            {{nation.label}}
                          </mat-option>
                        </mat-select>
                        <mat-error *ngIf="personalDetailForm.controls.NationalityId.errors && (personalDetailForm.controls.NationalityId.dirty || personalDetailForm.controls.NationalityId.touched)">
                          <p *ngIf="personalDetailForm.controls.NationalityId.errors?.required">{{translation['Nationality']}} {{translation['isRequired']}}</p>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-12 field-container identification-type">
                      <div class="form-label">{{translation['IdentificationType']}}</div>
                      <mat-radio-group formControlName="LegalIdTypeId" class="legalidtypeid-container">
                        <ng-container *ngFor="let legal of legalIdTypeIdList">
                          <mat-radio-button [value]="legal['value']" (change)="checkIdentificationTypeValidation($event)">{{legal['label']}}</mat-radio-button>
                        </ng-container>
                      </mat-radio-group>
                    </div>
                    <div class="col-12 field-container">
                      <div class="form-label" *ngIf="selectedLegalIdOption == '1'">{{translation['NationalID']}}<span class="required-class"> *</span></div>
                      <div class="form-label" *ngIf="selectedLegalIdOption == '2'">{{translation['ResidentID']}}<span class="required-class"> *</span></div>
                      <div class="form-label" *ngIf="selectedLegalIdOption == '3'">{{translation['Passport']}}<span class="required-class"> *</span></div>
                      <mat-form-field>
                        <input type="text" matInput formControlName="LegalId" [placeholder]="legalIdPlaceholder" autocomplete="off" (keydown)="allowOnlyEnglish($event)" (paste)="blockNonEnglishPaste($event)">
                      
                        <mat-error *ngIf="personalDetailForm.controls.LegalId.errors && (personalDetailForm.controls.LegalId.dirty || personalDetailForm.controls.LegalId.touched)">
                          <ng-container *ngIf="selectedLegalIdOption == '1'">
                            <p *ngIf="personalDetailForm.controls.LegalId.errors?.required">{{translation['NationalID']}} {{translation['isRequired']}}</p>
                            <p *ngIf="personalDetailForm.controls.LegalId.errors?.pattern">{{translation['NationalID']}} {{translation['NationalIDLengthValidation']}}.</p>
                          </ng-container>
                          <ng-container *ngIf="selectedLegalIdOption == '2'">
                            <p *ngIf="personalDetailForm.controls.LegalId.errors?.required">{{translation['ResidentID']}} {{translation['isRequired']}}</p>
                            <p *ngIf="personalDetailForm.controls.LegalId.errors?.pattern">{{translation['ResidentID']}} {{translation['ResidentIDLengthValidation']}}.</p>
                          </ng-container>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-6 dob">
                      <div class="form-label">{{translation['DateOfBirth']}}<span class="required-class"> *</span></div>
                      <div style="display: flex;">
                        <mat-form-field>
                          <mat-select placeholder="{{translation['Year']}}" [(ngModel)]="yearValue" [ngModelOptions]="{standalone: true}" autocomplete="off" (selectionChange)="checkLeapYear()">
                            <mat-option *ngFor="let year of dropDownValues['YearList']" [value]="year.value">
                              {{year.label}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                          <mat-select placeholder="{{translation['Month']}}" [(ngModel)]="monthValue" [ngModelOptions]="{standalone: true}" autocomplete="off" (selectionChange)="getDateList()">
                            <mat-option *ngFor="let month of dropDownValues['MonthList']" [value]="month.value">
                              {{month.label}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                          <mat-select placeholder="{{translation['Date']}}" [(ngModel)]="dayValue" [ngModelOptions]="{standalone: true}" autocomplete="off" (selectionChange)="validateAge()">
                            <mat-option *ngFor="let day of finalDayList" [value]="day">
                              {{day}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-12 mb-3" *ngIf="yearValue || monthValue || dayValue">
                      <div class="eligible" *ngIf="eligible">{{translation['EligibilityYesMsg']}}</div>
                      <div class="noteligible" *ngIf="!eligible">{{translation['EligibilityNoMsg']}}</div>
                    </div>
                    <div class="col-12 field-container">
                      <div class="form-label">{{translation['JoinOnlineHRMSID']}}</div>
                      <mat-form-field>
                        <input type="text" matInput formControlName="HRMSID" autocomplete="off" (keydown)="allowOnlyEnglish($event)" (paste)="blockNonEnglishPaste($event)" maxlength="5"
  (input)="cleanNumericInput($event)" placeholder="2xxxx or 3xxxx">
                        <mat-error *ngIf="personalDetailForm.controls.HRMSID.errors && (personalDetailForm.controls.HRMSID.dirty || personalDetailForm.controls.HRMSID.touched)">
                          <p *ngIf="personalDetailForm.controls.HRMSID.errors?.required">{{translation['HRMSID']}} {{translation['isRequired']}}</p>
                          <p *ngIf="personalDetailForm.controls.HRMSID.errors?.nonNumeric">{{translation['HRMSID']}} {{translation['nonNumericError']}}</p>
                          <p *ngIf="personalDetailForm.controls.HRMSID.errors?.maxLengthExceeded">{{translation['HRMSID']}} {{translation['maxLengthExceededError']}}</p>
                          <p *ngIf="personalDetailForm.controls.HRMSID.errors?.startsWithInvalidDigit">{{translation['HRMSID']}} {{translation['startsWithInvalidDigit']}}</p>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="terms-container">
                  <div><mat-checkbox color="accent" [(ngModel)]="checked"></mat-checkbox>&nbsp;&nbsp;{{translation['TermsAndConditionsLabelMsg']}} <a target="_blank" (click)="goToTerms()">{{translation['TermsAndConditions']}}</a></div>
                </div>
                <div *ngIf="errorMsg">
                  <div class="form-label" style="text-align: center;">{{errorMsg}}</div>
                </div>
                <div class="footer">
                  <button mat-button (click)="addMemberFromJoinOnlineWebsite()" [disabled]="personalDetailForm.invalid || !checked">{{translation['ContinueToPayment']}}</button>
                </div>
              </mat-step>
              <mat-step editable="false">
                <ng-template matStepLabel>{{translation['Payment']}}</ng-template>
                <div class="grid btn-header">
                  <div class="col-12">
                    <button class="back-button" mat-button matStepperPrevious>{{translation['Back']}}</button>
                  </div>
                </div>
                <div class="detail-bg-container payment-container" [formGroup]="personalDetailForm">
                  <div class="personal-details-header">{{translation['PaymentMethod']}}</div>
                  <div class="grid payment-detail-form">
                    <div *ngIf="ShowTabbyPaymentButton" class="payment-option" (click)="selectPaymentMode('Tabby')">
                      <div class="img-section">
                        <img src="./assets/icons/tabby.png">
                      </div>
                      <div class="description">
                        {{translation['Tabby']}}
                      </div>
                    </div>
                    <div *ngIf="ShowTamaraPaymentButton" class="payment-option" (click)="selectPaymentMode('Tamara')">
                      <div class="img-section">
                        <img src="./assets/icons/tamara.png">
                      </div>
                      <div class="description">
                        {{translation['Tamara']}}
                      </div>
                    </div>
                    <div *ngIf="ShowCardPaymentButton" class="payment-option" (click)="selectPaymentMode('Card')">
                      <div class="img-section">
                        <img src="./assets/icons/credit-card.png">
                      </div>
                      <div class="description">
                        {{translation['Credit/DebitCard']}}
                      </div>
                    </div>
                  </div>
                </div>
              </mat-step>
            </mat-horizontal-stepper>
          </div>
        </div>
    </div>
</div>